import { gql } from '@apollo/client';

import { SUGGEST_CHANGE_FIELDS } from './suggestChange.fragment';

export * from './suggestedChanges.query.generated';

export const SUGGESTED_CHANGES = gql`
  ${SUGGEST_CHANGE_FIELDS}
  query SuggestedChanges($escrowId: ID!, $changeType: SuggestedChangeChangeTypeEnum) {
    suggestedChanges(escrowId: $escrowId, changeType: $changeType, status: pending) {
      nodes {
        ...SuggestChangeFields
      }
    }
  }
`;
